import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import PageMeta from "../common/PageMeta";
import PageBreadcrumb from "../common/PageBreadCrumb";
import ComponentCard from "../common/ComponentCard";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "../ui/table";

import {
  TrashBinIcon,
  PencilIcon
} from "../../icons";

import { Link } from "react-router";
import Badge from "../ui/badge/Badge";  
import { getAllUserSubscription, resetGetAllUserSubscription, emptyRedux } from "../../actions/subscriptionAction";
import { createPaymentRequestData, resetCreatePaymentRequestData } from "../../actions/paymentAction";
import { checkAuth } from "../../actions/userAction";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../helpers/userAuth';
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import Button from "../ui/button/Button";
import { configPaths } from '../../config';

export default function MySubscriptions() {

  dayjs.extend(relativeTime);

  const navigate = useNavigate();
  
  const dispatch = useDispatch();

  const [userSubscriptions, setUserSubscriptions] = useState([]);

  const getAllUserSubscriptionRes = useSelector(state => state.subscriptionReducer.getAllUserSubscription);

  const getAllUserSubscriptionFailed = useSelector(state => state.subscriptionReducer.getAllUserSubscriptionFailed);

  const createPaymentRequestDataRes = useSelector(state => state.paymentReducer.createPaymentRequestData);

  const createPaymentRequestDataFailed = useSelector(state => state.paymentReducer.createPaymentRequestDataFailed);

  const checkAuthFailed = useSelector(state => state.userReducer.checkAuthFailed);

  const badgeClasses = {
    in_progress: ["In Progress", "inline-flex items-center px-2.5 py-0.5 justify-center gap-1 rounded-full font-medium text-sm bg-brand-50 text-brand-500 dark:bg-brand-500/15 dark:text-brand-400"],
    completed: ["Completed", "inline-flex items-center px-2.5 py-0.5 justify-center gap-1 rounded-full font-medium text-sm bg-success-50 text-success-600 dark:bg-success-500/15 dark:text-success-500"],
    on_hold: ["On Hold", "inline-flex items-center px-2.5 py-0.5 justify-center gap-1 rounded-full font-medium text-sm bg-error-50 text-error-600 dark:bg-error-500/15 dark:text-error-500"]
  }
  
  useEffect(() => {

    dispatch(getAllUserSubscription());
  }, []);


  useEffect(() => {
      
    if(typeof getAllUserSubscriptionRes != "undefined" && getAllUserSubscriptionRes.statusCode == 200){

      let data = [];

      let userSubscriptionList = getAllUserSubscriptionRes.data.userSubscriptions;

      const userSubscriptionData = userSubscriptionList.map((item) => {

              return {
                id: item.id,
                subscriptionPlanId: item.subscriptionPlanId,
                userId: item.userId,
                startDate: item.startDate,
                endDate: item.endDate,
                status: item.status,
                createdAt: item.createdAt,
                updatedAt: item.updatedAt,
                subscriptionPlan: item.subscriptionPlan,
                user: item.user,
                payment: item?.payment
              };
      });
      

      setUserSubscriptions([
          ...userSubscriptionData
      ]);

    }

  }, [getAllUserSubscriptionRes]);

  useEffect(() => {

    if(typeof createPaymentRequestDataRes != "undefined" && createPaymentRequestDataRes.statusCode == 200){
        console.log(createPaymentRequestDataRes);
    }
    
  }, [createPaymentRequestDataRes]);

  const handlePaymentRequestData = (payment_id = null) => {

      if(payment_id != null && payment_id != "") {

        //dispatch(createPaymentRequestData(userSubscriptionId));
        //navigate(configPaths.apiPath+'payu/createNewPaymentRequest/'+payment_id);
        window.location.href = configPaths.apiPath.replace("api/","")+'payu/createNewPaymentRequest/'+payment_id;
      } else {

        toast.error("Something went wrong..! Please try again later.");
        return;
      }
  };

  return (
    <>
      <PageMeta
        title="My subscriptions | Chit Fund Management System"
        description="Chit Fund Management System"
      />
      <PageBreadcrumb pageTitle="My subscriptions" />
      <div className="space-y-6">
        <ComponentCard title="All subscriptions list">
          <div className="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-white/[0.05] dark:bg-white/[0.03]">
            <div className="max-w-full overflow-x-auto">
              <div className="min-w-[1102px]">
                <Table>
                  {/* Table Header */}
                  <TableHeader className="border-b border-gray-100 dark:border-white/[0.05]">
                    <TableRow>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Plan name
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Schedule
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Duration
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Created At
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Status
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHeader>

                  {/* Table Body */}
                  <TableBody className="divide-y divide-gray-100 dark:divide-white/[0.05]">
                  {
                      userSubscriptions.length > 0 

                      ?

                      userSubscriptions.map((item) => (

                      <TableRow key={item.id}>
                        
                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                          {item.subscriptionPlan.name}
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                        {(
                            item.subscriptionPlan.scheduleType === "fixed"
                            ?
                            item.subscriptionPlan.tenure + ' ' + (item.subscriptionPlan.schedule == "monthly" ? "month(s)" : (item.subscriptionPlan.schedule == "weekly" ? "week(s)" : "year(s)"))
                            :
                            "-"
                          )}
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                          <div className="flex -space-x-2">
                            From {dayjs(item.startDate).format('DD/MM/YYYY')} {(item.subscriptionPlan.scheduleType === "fixed" ? "to " + dayjs(item.endDate).format('DD/MM/YYYY') : "")}
                          
                          </div>
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                          {dayjs(item.createdAt).format('DD/MM/YYYY') }
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                          <span className={badgeClasses[item.status][1]}>{badgeClasses[item.status][0]}</span>
                        </TableCell>
                        <TableCell className="text-center px-4 py-3 text-gray-500 text-theme-sm dark:text-gray-400">
                        <div className="flex flex-cols-2 gap-6 xl:grid-cols-2">
                            <div className="space-y-6">
                            <Link
                              to={"javascript:void(0)"}
                              className="text-indigo-600 ring-1 ring-indigo-200 ring-inset hover:ring-indigo-300 shadow-xs focus-visible:outline-indigo-500 rounded-md px-2.5 py-2.5 text-center text-sm inline-block"
                            >
                              <PencilIcon />
                            </Link>
                            </div>
                            <div className="space-y-6">
                            <Link
                              to={"javascript:void(0)"}
                              className="text-indigo-600 ring-1 ring-indigo-200 ring-inset hover:ring-indigo-300 shadow-xs focus-visible:outline-indigo-500 rounded-md px-2.5 py-2.5 text-center text-sm inline-block"
                            >
                              <TrashBinIcon />
                            </Link>
                            </div>
                            <div className="space-y-6">

                            {( item?.payment?.status === "pending" || item?.payment?.status === "failed" 
                              ?
                              <Button size="sm" variant="primary" onClick={(e) => handlePaymentRequestData(item.payment.id)}>
                                Pay Now
                              </Button>
                              :
                              null
                            )}
                            </div>
                          </div>
                        </TableCell>
                      </TableRow>
                      
                    ))
                    :
                      <TableRow>
                        <td colSpan={6} className="text-center py-6 text-gray-500">No Records Found..!</td>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </div>
            </div>
          </div>
        </ComponentCard>
      </div>
    </>
  );
}